'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import { topCardsPlansDetails } from '@/src/constants/Pricing';
import { dashboardUrl } from '@/src/utils';
import { goToPartnerPage, sendAnalyticsData } from '@/src/utils/analytics';
import { FAQs } from '../Faqs';
import type { IPricingTopCardsPlan } from '../home.interface';
import { Reviews } from '../Reviews';
import { PricingTablularComparePlans } from './PricingTablularComparePlans';
import { PricingTopCards } from './PricingTopCards';
export const Pricing = () => {
  const $ = _c(19);
  const [togglebutton, settogglebutton] = useState(true);
  const signupUrl = `${dashboardUrl}/signup`;
  let t0;
  if ($[0] !== togglebutton) {
    t0 = ctaText => {
      settogglebutton(!togglebutton);
      sendAnalyticsData("DURATION_TYPE_BUTTON_CLICKED_FROM_PRICING", {
        ctaText
      });
    };
    $[0] = togglebutton;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handletogglebutton = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <style jsx={true}>{"\n          /* @font-face and .font-sans for shyest-regular removed. */\n          /* Handled globally by next/font and Tailwind (font-shyest) */\n        "}</style>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mx-4 flex flex-col items-center justify-center"><h1 className="w-[65%] text-center text-[22px] font-medium text-[#3D3E40] md:mx-0 lg:text-[36px]">Supercharge Your <br className="md:hidden" />Caseload Management</h1><p className="mt-2 text-center text-lg font-normal text-[#555659] md:mx-auto  md:w-[60%] md:text-center lg:mt-4 lg:text-lg">Digitize your special education workflows with the only caseload management tool that offers IEP Goal Tracking, Reporting, Service Time Tracking, Medicaid Billing, and more.</p></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== handletogglebutton) {
    t3 = topCardsPlansDetails.filter(_temp).map((_planData_0, index) => <div className={`flex flex-col rounded-[32px] p-12 ${_planData_0.amount === "Custom" ? "bg-[#F7FCFF]" : "border bg-white"}`} key={index}><PricingTopCards planData={_planData_0} key={index} /><div className=" mt-auto flex px-2 md:px-0"><Link href={_planData_0.amount !== "Custom" ? signupUrl : "custom-pricing-form"} onClick={() => {
          sendAnalyticsData(`${_planData_0.ctaText.replace(" ", "_").toUpperCase()}_BUTTON_CLICKED_FROM_PRICING`);
        }} style={{
          color: _planData_0.buttonStyle === "no-border" ? "#fff" : "#318AE5"
        }} className={`w-full rounded-lg border-2 border-[#318AE5] py-3 text-lg font-medium ${_planData_0.buttonStyle === "no-border" ? "bg-[#318AE5] hover:bg-white hover:text-[#318AE5] hover:shadow" : "bg-white hover:bg-[#318AE5] hover:text-white hover:shadow"}`}>{_planData_0.ctaText}</Link></div><div className="block text-center text-[15px] font-medium text-[#318AE5] md:hidden lg:my-6">{_planData_0.durationtype && <button onClick={() => handletogglebutton(_planData_0.ctaText)} className="my-4">{_planData_0.durationtype}</button>}</div></div>);
    $[4] = handletogglebutton;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <div className="mx-[7%] inline-grid grid-cols-1 content-center gap-8 md:grid-cols-2  ">{t3}</div>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mx-12 my-9 text-left"><h2 className="text-xl font-medium text-[#3D3E40]">Need help with Purchase Orders for School Districts?</h2><p className="w-[95%] text-lg text-[#616366]">If you would like your school or district to purchase a subscription for you, we can help out at every step along the way.</p></div>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="mx-[7%] mt-8 hidden rounded-[32px] bg-[#FAFBFC] md:flex ">{t5}<div className="mx-12 flex w-[20%] text-[#318AE5] lg:mx-4 lg:w-[30%]"><Link href="/schools-and-districts#freq-used-docs" className=" m-auto flex text-lg font-medium" onClick={_temp2}>Learn More<Image src="/images/icons/pricing/bulk-purchase/Vector.svg" alt="Arrow" className="m-auto mx-3" width={20} height={20} /></Link></div></div>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="mx-2 mt-20 lg:mx-[120px]"><PricingTablularComparePlans /></div>;
    t8 = <hr className="mx-24 hidden border-[1px] border-[#ECEEF0] md:block" />;
    $[10] = t7;
    $[11] = t8;
  } else {
    t7 = $[10];
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t4) {
    t9 = <div className="mt-4 pt-10 md:pb-20">{t4}{t6}{t7}{t8}</div>;
    $[12] = t4;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      color: "#fff"
    };
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="mx-[14%] -mt-12 hidden justify-end gap-x-10 md:flex "><a style={t10} className="mb-8 flex cursor-pointer items-center gap-x-1 self-center rounded-xl border-[1px] border-solid border-[#318AE5] bg-[#318AE5] px-5 py-3 text-[16px] font-medium  " onClick={() => goToPartnerPage(signupUrl)}>Start for FREE!</a><div><Link href="custom-pricing-form" onClick={_temp3} className="flex cursor-pointer items-center gap-x-1 self-center rounded-xl border-[1px] border-solid border-[#318AE5] px-[34px] py-3 text-[16px] font-medium text-[#318AE5] hover:bg-[#318AE5] hover:text-white">Contact us</Link><p className="mt-2 text-sm text-[#464E5F]">For Schools/Districts</p></div></div>;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="lg:mt-16 "><Reviews /><FAQs tag="pricing" /></div>;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t9) {
    t13 = <section className="mt-16 md:mt-36">{t1}<div className="container mx-auto py-16 text-center md:px-0">{t2}{t9}{t11}{t12}</div></section>;
    $[17] = t9;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  return t13;
};
export default Pricing;
function _temp(_planData) {
  if (_planData.amount === "Free" || _planData.amount === "Custom") {
    return true;
  }
  return _planData.duration === "/month";
}
function _temp2() {
  return sendAnalyticsData("BULK_PURCHASE_LEARN_MORE_BUTTON_CLICKED");
}
function _temp3() {
  return sendAnalyticsData("CONTACT_US_BUTTON_CLICKED_FROM_PRICING");
}